import * as React from "react";

const ArrowGalleryMobile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={43.5}
    height={192}
    viewBox="0 0 43.5 192"
    {...props}
  >
    <g id="Grupo_8" data-name="Grupo 8" transform="translate(-148 -769.5)">
      <g
        id="Icon_feather-arrow-down"
        data-name="Icon feather-arrow-down"
        transform="translate(170 770)"
      >
        <path
          id="Trazado_4"
          data-name="Trazado 4"
          d="M18,199a.5.5,0,0,1-.5-.5V7.5a.5.5,0,0,1,1,0v191A.5.5,0,0,1,18,199Z"
          transform="translate(-7.5 -7.5)"
          fill="#dadada"
        />
        <path
          id="Trazado_5"
          data-name="Trazado 5"
          d="M18,30.438a.5.5,0,0,1-.375-.17L7.125,18.33a.5.5,0,0,1,.751-.66L18,29.18,28.125,17.67a.5.5,0,0,1,.751.66l-10.5,11.937A.5.5,0,0,1,18,30.438Z"
          transform="translate(-7.5 161.063)"
          fill="#dadada"
        />
      </g>
      <text
        id="Gallery"
        transform="translate(165 859) rotate(-90)"
        fill="#dadada"
        fontSize={20}
        fontFamily="CutiveMono-Regular, Cutive Mono"
        letterSpacing="0.347em"
      >
        <tspan x={-63.203} y={0}>
          {"Gallery"}
        </tspan>
      </text>
    </g>
  </svg>
);

export default ArrowGalleryMobile;
